export const imageBaseUrl = "https://dzwa28iejunh3.cloudfront.net/";
export const _PublicImageBaseUrl = "https://dzwa28iejunh3.cloudfront.net/";

export const _CredoLogo = `${_PublicImageBaseUrl}credoLogo.svg`;